import { Vue, Component } from 'vue-property-decorator';
import LoadingModule from '@/store/modules/loading';
import { getModule } from 'vuex-module-decorators';

export enum ApiStatus {
  PENDING = 'pending',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type ApiStatusList =
  | ApiStatus.PENDING
  | ApiStatus.LOADING
  | ApiStatus.SUCCESS
  | ApiStatus.ERROR;

@Component
export default class ApiStatusMixin extends Vue {
  loadingModule: LoadingModule | null = null;

  apiStatus: ApiStatusList = ApiStatus.PENDING;

  get isApiPending() {
    return this.apiStatus === ApiStatus.PENDING;
  }

  get isApiLoading() {
    return this.apiStatus === ApiStatus.LOADING;
  }

  get isApiSuccess() {
    return this.apiStatus === ApiStatus.SUCCESS;
  }

  get isApiError() {
    return this.apiStatus === ApiStatus.ERROR;
  }

  setApiStatus(status: ApiStatusList) {
    this.apiStatus = status;
  }

  setApiPending() {
    this.setApiStatus(ApiStatus.PENDING);

    if (this.loadingModule) {
      this.loadingModule.stop();
    }
  }

  setApiLoading() {
    this.setApiStatus(ApiStatus.LOADING);

    if (this.loadingModule) {
      this.loadingModule.start();
    }
  }

  setApiSuccess() {
    this.setApiStatus(ApiStatus.SUCCESS);

    if (this.loadingModule) {
      this.loadingModule.stop();
    }
  }

  setApiError() {
    this.setApiStatus(ApiStatus.ERROR);

    if (this.loadingModule) {
      this.loadingModule.stop();
    }
  }

  created() {
    this.loadingModule = getModule(LoadingModule, this.$store);
  }
}
